import { useEffect, useState } from "react";

import type { ActivatedChildComponentType } from "../BaseActivatedPanel/types";

import { StyledWrapper } from "./styles";
import type { TableActionsPanelProps } from "./types";

const TableActionsPanel = ({ children, className, defaultActiveChild }: TableActionsPanelProps) => {
    const [CurrentlyActiveChild, activateChild] = useState<ActivatedChildComponentType | null>(
        () => defaultActiveChild ?? null,
    );

    useEffect(() => {
        if (defaultActiveChild) {
            activateChild((current: ActivatedChildComponentType | null) => current ?? defaultActiveChild);
        }
    }, [defaultActiveChild]);

    return (
        <StyledWrapper
            data-automation="table-actions-panel"
            data-automation-active={CurrentlyActiveChild !== null}
            className={className}
        >
            {CurrentlyActiveChild === null ? children({ activate: activateChild }) : null}
            {CurrentlyActiveChild === null ? null : <CurrentlyActiveChild onDeactivate={() => activateChild(null)} />}
        </StyledWrapper>
    );
};

export default TableActionsPanel;
